import {
  apiCustomerURL,
  apiMerchantURL,
  apiOpenDeliveryURL,
  apiOrdersURL,
} from "@/consts";
import axios from "axios";
import { ensureGuestToken, currentGuestToken, hasRecoverableGuestSession, GuestRecoveryUnavailableError } from "@/lib/guest-session";

/** Axios client with the JSON headers shared by every service API. */
const createJsonClient = (baseURL: string) =>
  axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

export const apiMerchant = createJsonClient(apiMerchantURL);

/** Merchant client for unauthenticated routes at the host root. */
export const apiMerchantPublic = createJsonClient(apiMerchantURL.replace(/\/merchants\/?$/, ""));

export const apiOpenDelivery = createJsonClient(apiOpenDeliveryURL);

export const apiOrders = createJsonClient(apiOrdersURL);

export const apiCustomer = createJsonClient(apiCustomerURL);

apiCustomer.interceptors.request.use(async (config) => {
  const token = await ensureGuestToken();

  if (!token || currentGuestToken() !== token) {
    if (hasRecoverableGuestSession()) throw new GuestRecoveryUnavailableError();
    throw new Error("Token de autenticação não encontrado");
  }

  config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

/** Customer client for public guest login, checks and recovery. */
export const apiCustomerPublic = createJsonClient(apiCustomerURL);
